import PropTypes from "prop-types";
import { ColorCard, ColorPallet } from 'admin/views/site-designer/modules/sections/components/Color';
import { DotsOptions } from 'admin/views/site-designer/modules';
import { getSiteName } from 'common/utils/helper';
import ConfirmModal from 'common/components/modules/modal-wrapper';
import { createPortal } from 'react-dom';
import Button from 'common/components/elements/buttons/primary';
import cx from 'classnames';
import { useState } from "react";
import Input from "common/components/elements/inputs/inputs";
import Icon from "common/components/elements/icons";

const MODIFY_MODAL_DEFAULT_STATE = {
   isOpen: false,
   type: null,
   color: null,
   title: '',
   key: null,
};
const DELETE_MODAL_DEFAULT_STATE = {
   isOpen: false,
   key: null,
   type: null,
   title: null,
   selected: false,
};

const SiteColors = ({ value, onChange }) => {
   const [modifyColorModal, setModifyColorModal] = useState(MODIFY_MODAL_DEFAULT_STATE);
   const [deleteColorModal, setDeleteColorModal] = useState(DELETE_MODAL_DEFAULT_STATE);
   const COLORS = Object.keys(value);
   return (
      <>
         {
            deleteColorModal.isOpen && (
               <CustomColorModal
                  type={ deleteColorModal.type }
                  title={ deleteColorModal.title }
                  onCloseModal={ () => setDeleteColorModal(DELETE_MODAL_DEFAULT_STATE) }
                  action={ (type) => {
                     setDeleteColorModal(DELETE_MODAL_DEFAULT_STATE);
                     if('delete' === type && deleteColorModal.selected){
                        setDeleteColorModal({
                           ...deleteColorModal,
                           type: 'delete_warning',
                        });
                        return;
                     }
                     onChange(deleteColorModal.key, {
                        ...value[deleteColorModal.key],
                        is_deleted: 'revert' !== type,
                        selected: false,
                     });
                     if('delete_warning' === type && deleteColorModal.selected){
                        onChange('color_mymember_site', {
                           ...value.color_mymember_site,
                           selected: true,
                        });
                     }
                     if(modifyColorModal?.isOpen){
                        setModifyColorModal(MODIFY_MODAL_DEFAULT_STATE);
                     }
                  } }
               />
            )
         }
         {
            modifyColorModal?.isOpen && (
               <CustomColorModal
                  type={ modifyColorModal.type }
                  title={ modifyColorModal.title }
                  color={ modifyColorModal.color }
                  onCloseModal={ () => {
                     setModifyColorModal(MODIFY_MODAL_DEFAULT_STATE);
                  } }
                  onDeletePallet={ () => setDeleteColorModal({
                     isOpen: true,
                     key: modifyColorModal.key,
                     title: modifyColorModal.title,
                     selected: modifyColorModal.selected,
                     type: 'delete',
                  }) }
                  action={ (type) => {
                     let key = modifyColorModal.key;
                     if(type === 'add'){
                        key = `color_${ modifyColorModal.title.replaceAll(' ', '_') }`;
                     }
                     const payload = {
                        is_custom: true,
                        primary_color: modifyColorModal.color,
                        title: modifyColorModal.title,
                        selected: false,
                     };
                     onChange(key, payload);
                     setModifyColorModal(MODIFY_MODAL_DEFAULT_STATE);
                  } }
                  onChange={ (name, value) => {
                     setModifyColorModal({
                        ...modifyColorModal,
                        [name]: value,
                     });
                  } }
               />
            )
         }

         <div className='w-full h-full flex flex-col gap-2'>
            <div className='h-6 w-[167px]'>
               <Button
                  text='Add custom color'
                  padding='none'
                  iconName='add'
                  iconPosition='left'
                  backgroundColor='transparent'
                  primaryColor
                  onClick={ () => {
                     setModifyColorModal({
                        isOpen: true,
                        type: 'add',
                        color: '#FF2480',
                        title: '',
                        key: null,
                     });
                  } }
                  textSize='small'
               />
            </div>
            {
               COLORS.map(key => {
                  const color = value[key];
                  if('color' === color.type) return null;
                  return (
                     <div
                        key={ key }
                        role='presentation'
                        onClick={ () => {
                           if(!color.is_deleted && !color.selected){
                              const oldSelected  = COLORS.find(color => value?.[color]?.selected);
                              if(oldSelected){
                                 onChange(oldSelected, {
                                    ...value[oldSelected],
                                    selected: false,
                                 });
                              }
                              onChange(key, {
                                 ...color,
                                 selected: true,
                              });
                           } else {
                              onChange(key, {
                                 ...color,
                                 selected: false,
                              });
                           }
                        }
                        }
                        className={ cx({
                           'flex py-3 px-4 bg-panel rounded-lg items-center justify-between cursor-pointer': true,
                           'border-2 border-action': color.selected && !color.is_deleted,
                           'border border-divider': !color.selected && !color.is_deleted,
                           'border border-error': color.is_deleted,
                        }) }
                     >
                        <div className='flex items-center gap-1'>
                           {
                              Boolean(color?.is_custom) && (
                                 <DotsOptions
                                    options={ [
                                       { value: 'edit', title: 'Edit', icon: 'pencil', color: 'action' },
                                       { value: 'delete', title: 'Delete', icon: 'delete', color: 'error' },
                                    ] }
                                    tooltipId={ `site_custom_color_${ key }_dots_tootltip` }
                                    onClickOptions={ (value) => {
                                       if('edit' === value){
                                          setModifyColorModal({
                                             isOpen: true,
                                             type: 'edit',
                                             color: color.primary_color,
                                             title: color.title,
                                             selected: color.selected,
                                             key: key,
                                          });
                                          return
                                       }
                                       // if 'delete' === value
                                       setDeleteColorModal({
                                          isOpen: true,
                                          key: key,
                                          type: 'delete',
                                          title: color.title,
                                          selected: color.selected,
                                       })

                                    } }
                                    showRevertButton={ Boolean(color.is_deleted) }
                                    onClickRevert={ () => {
                                       setDeleteColorModal({
                                          isOpen: true,
                                          key: key,
                                          type: 'revert',
                                          title: color.title,
                                          selected: color.selected,
                                       });
                                    } }
                                 />
                              )
                           }
                           {
                              'mymember.site' === color.title && (
                                 <span
                                    dangerouslySetInnerHTML={ { __html: getSiteName() } }
                                 />
                              )
                           }
                           {
                              'mymember.site' !== color.title && (
                                 <span
                                    className='text-black text-base leading-[20px]'
                                 >
                                    {color.title}
                                 </span>
                              )
                           }

                        </div>
                        <ColorCard
                           color={ color.primary_color }
                           isCustomColor
                        />
                     </div>
                  )
               })
            }
         </div>
      </>
   );
};


const CustomColorModal = ({
   type,
   color,
   title = '',
   onCloseModal,
   onDeletePallet,
   action,
   onChange,
}) => {
   const [openColorPicker, setOpenColorPicker] = useState(false);
   const getState = () => {

      const state = {
         add: {
            icon: 'add',
            type: 'action',
            title: 'Add custom palette',
            buttonText: 'Save',
            disabled: !color || !title,
         },
         edit: {
            icon: 'pencil',
            type: 'action',
            title: 'Edit custom palette',
            secondButtonTitle: 'Delete this palette',
            secondButtonPosition: 'bottom',
            secondButtonClassName: 'mt-3',
            buttonText: 'Save',
            overrideSecondButtonProps: {
               textColor: 'error',
            },
            secondButtonAction: _ => onDeletePallet(),
            disabled: !color || !title,
         },
         delete: {
            icon: 'delete',
            type: 'confirm',
            title: `Delete ${ title } palette?`,
            description: `Are you sure you want to delete ${ title }?`,
            buttonText: 'Yes. delete',
            nonPrimaryColor: true,
            textColor: 'error',
            cancelText: 'Cancel',
            iconColor: 'error',

         },
         delete_warning: {
            icon: 'warning',
            type: 'confirm',
            title: 'Warning',
            description: `This ${ title } is currently set as your site color. If you delete it, the default ${ getSiteName() } colors will be applied automatically.`,
            buttonText: `Ok, delete ${ title }`,
            nonPrimaryColor: true,
            textColor: 'action',
            cancelText: 'Cancel',
            iconColor: 'warning',

         },
         revert: {
            icon: 'revert',
            type: 'confirm',
            title: `Revert ${ title } palette?`,
            description: `Are you sure you want to revert ${ title }?`,
            buttonText: 'Yes. revert',
            nonPrimaryColor: true,
            textColor: 'error',
            cancelText: 'Cancel',
            iconColor: 'error',

         },
      }
      return state[type]
   }
   return (
      <ConfirmModal
         { ...getState() }
         contentWidth='375px'
         onCloseModal={ onCloseModal }
         isPreventDeafault={ false }
         action={ () => action(type) }
      >
         {
            ['add', 'edit'].includes(type) && (
               <div className='flex flex-col w-full gap-7'>
                  <Input
                     name='title'
                     label='Palette name'
                     description={ `${ title.length } of 25 characters` }
                     placeholder='Enter custom palette name'
                     value={ title }
                     onChange={ onChange }
                     descriptionPosition='right'
                  />
                  <div className='bg-grey-main rounded-lg p-[10px] flex flex-col items-center gap-4'>
                     <span className='text-major leading-[20px]'>Site color</span>
                     <div
                        role='presentation'
                        onClick={ (e) => {
                           setOpenColorPicker(!openColorPicker);
                        } }
                        data-tooltip-id='color-picker-section'
                        className='h-20 w-20 rounded-full flex items-center justify-center cursor-pointer'
                        style={ {
                           background: color,
                        } }>
                        <div className='h-6 w-6 flex items-center justify-center'>
                           <Icon
                              color='major-dark'
                              name='color-picker'
                              size='lg'
                           />
                        </div>
                     </div>
                     <div className='relative  w-full'>
                        <span className='absolute z-10' style={ {
                           top: '12px',
                           left: '13px',
                        } }>#</span>
                        <Input
                           name='color'
                           inputClassName='!pl-6'
                           value={ color && color.replace('#', '') }
                           onChange={ onChange }
                        />
                     </div>
                     {
                        createPortal(
                           <ColorPallet
                              openColorPicker={ openColorPicker }
                              color={ color }
                              handleChangeColor={ (color) => {
                                 onChange('color', color.hex);
                              } }
                              id='color-picker-section'
                           />,
                           document.getElementById('tooltips')
                        )
                     }
                  </div>
               </div>
            )
         }
      </ConfirmModal>
   )
}

SiteColors.propTypes = {
   value: PropTypes.object,
   onChange: PropTypes.func,
};
CustomColorModal.propTypes = {
   type: PropTypes.string,
   color: PropTypes.string,
   title: PropTypes.string,
   onCloseModal: PropTypes.func,
   onDeletePallet: PropTypes.func,
   action: PropTypes.func,
   onChange: PropTypes.func,
};

export default SiteColors;
